import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import FormField from './form-input';
import useLanguage from '../../hooks/useLanguage';

const SearchFilter = ({
    isView = true,
    handleSearch = () => { },
    handleFilterInput = () => { },
    reset = () => { },
    value = "",
    disabled = false,
    otherAction
}) => {
    const { t, isEngLang } = useLanguage();

    const btnClass = "custom_button bg-green-color white-color ms-3 d-flex justify-content-around align-items-center"
    return (
        <>
            <div className="d-flex">
                {isView && <>
                    <FormField
                        name="search"
                        onChange={handleFilterInput}
                        value={value}
                        data={{
                            placeholder: `${t("filterTitle.search")}`,
                            type: 'text',
                            leftIcon: <SearchIcon className="ms-2 gray-color" />,
                        }}
                    />
                    <button
                        className={`${btnClass} bg-green-color ${!isEngLang && 'me-3'}`}
                        disabled={disabled}
                        onClick={handleSearch}
                    >
                        <SearchIcon size={20} className="me-1" />
                        <span className="me-1">{t("buttonTitle.search")}</span>
                    </button>
                    <button
                        className={`${btnClass} bg-blue-color me-3`}
                        disabled={disabled}
                        onClick={reset}
                    >
                        <RestartAltIcon size={20} className="me-1" />
                        <span className="me-1">{t("buttonTitle.reset")}</span>
                    </button>


                </>}

                {/* other action buttons */}
                {otherAction}
            </div>
        </>
    );
};

export default SearchFilter;
